<template>
  <div id="menu">
    <div id="nav">
      <!-- <a
        href="#banner"
        data-state="inactive"
        class="body-small nav-link banner"
      >
        <span>National Donut Day</span>
      </a> -->
      <a href="#about" data-state="inactive" class="body-small nav-link about">
        <span>About us</span>
      </a>
      <a href="#hours" data-state="inactive" class="body-small nav-link hours">
        <span>Store Hours</span>
      </a>
      <a
        href="#location"
        data-state="inactive"
        class="body-small nav-link location"
      >
        <span>Location</span>
      </a>
      <a
        href="#store-menu"
        data-state="inactive"
        class="body-small nav-link store-menu"
      >
        <span>Store Menu</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  mounted() {
    this.activeLink = false;
    this.setHash();
  },
  watch: {
    $route() {
      this.setHash();
    }
  },
  methods: {
    setHash() {
      let path = this.$router.currentRoute.hash;

      this.unsetActive();

      if (path) {
        path = path.replace("#", "");
        this.activeLink = this.$el.getElementsByClassName(path)[0];
        this.setActive();
      }
    },
    setActive() {
      this.activeLink.setAttribute("data-state", "active");
    },
    unsetActive() {
      if (this.activeLink) {
        this.activeLink.setAttribute("data-state", "inactive");
        this.activeLink = false;
      }
    }
  }
};
</script>

<style lang="scss">
#menu {
  height: 100%;
}
#nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  flex-wrap: wrap;
  a {
    margin-left: 25px;
    line-height: 100px;
    text-transform: uppercase;
    color: var(--color-dark-3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.4, 1) 0s;
    position: relative;
    span {
      pointer-events: none;
    }
    &:hover {
      color: var(--color-dark-5);
      text-decoration: none;
      &::after {
        height: 4px;
      }
    }
    &[data-state="active"] {
      color: var(--color-dark-1);
      &::after {
        height: 4px;
      }
    }
    &::after {
      content: "";
      height: 0px;
      background: #990000;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.4, 1) 0s;
    }
  }
}

@media only screen and (max-width: 490px) {
  #nav a {
    font-size: 10px !important;
    line-height: 3;
    margin-left: 15px;
  }
}
</style>
